/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocEditIcon20Solid = forwardRef('DocEditIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10.004 2H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h2.5v-.172a2 2 0 0 1 .586-1.414L16 10.5V7.998h-3.746a2.25 2.25 0 0 1-2.25-2.25V2Z" }),
        React.createElement("path", { d: "m15.863 6.498-4.359-4.359v3.609c0 .414.336.75.75.75h3.61Z" }),
        React.createElement("path", { d: "M11 18.414V19.5a.5.5 0 0 0 .5.5h1.086a1 1 0 0 0 .707-.293l4.803-4.803-2-2-4.803 4.803a1 1 0 0 0-.293.707Z" }),
        React.createElement("path", { d: "m19.682 13.318-.878.879-2-2 .878-.879a1 1 0 0 1 1.414 0l.586.586a1 1 0 0 1 0 1.414Z" })));
});
